import calculate from './fieldVisibility';
export default {
  calculate: calculate
};